import { render, staticRenderFns } from "./CheckboxIcon.vue?vue&type=template&id=4332cb66&scoped=true&"
import script from "./CheckboxIcon.vue?vue&type=script&lang=js&"
export * from "./CheckboxIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4332cb66",
  null
  
)

export default component.exports